module.exports = __webpack_public_path__ + "img/logo.22e01a5b.png";